import { render } from "./AdministratorQuestionContent.vue?vue&type=template&id=9def63d6"
import script from "./AdministratorQuestionContent.vue?vue&type=script&lang=js"
export * from "./AdministratorQuestionContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__